import { render, staticRenderFns } from "./bigfulltextlogo.vue?vue&type=template&id=2a5dfd06&scoped=true&"
var script = {}
import style0 from "./bigfulltextlogo.vue?vue&type=style&index=0&id=2a5dfd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5dfd06",
  null
  
)

export default component.exports